const config = {
  BUSINESS_BOOKING_API_URL: 'https://obbv2dtdcprod.shipsy.io',
  ONLINE_BOOKING_API_URL: 'https://ebookingbackend.shipsy.in',
  useOnlyForLocalTestingOrgId: '1',
  LOGO_URL: 'https://shipsy-public-assets.s3.amazonaws.com/generic/file-5fd13c93-273e-47f7-9e9d-2c24c1c6f3d8.jpg',
};
module.exports.default = config;
